// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16qG5","colBig":"styles_colBig__3JsHc","colSmall":"styles_colSmall__2mwhb"};